module.exports = __webpack_public_path__ + "static/media/IconIndicator.258e857d.svg";